<template>
  <div
    :class="['c-fontAwesomeIcon', className]"
    :style="iconStyle"
    v-bind="$attrs" />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  size: {
    type: [String, Number],
    default: 24,
  },
  className: {
    type: String,
    default: '',
  },
})

// Extract icon name from FontAwesome class (e.g., "far fa-home" -> "home")
const iconName = computed(() => {
  return props.icon.replace('far fa-', '')
})

// Computed style for the icon using CSS mask technique
const iconStyle = computed(() => {
  const sizeValue = typeof props.size === 'number' ? `${props.size}px` : props.size

  return {
    width: sizeValue,
    height: sizeValue,
    backgroundColor: 'currentColor',
    mask: `url('/img/fontawesome-regular/${iconName.value}.svg') no-repeat center`,
    maskSize: 'contain',
    WebkitMask: `url('/img/fontawesome-regular/${iconName.value}.svg') no-repeat center`,
    WebkitMaskSize: 'contain',
  }
})
</script>

<style scoped>
.c-fontAwesomeIcon {
  display: inline-block;
  flex-shrink: 0;
}
</style>
